import { render, staticRenderFns } from "./document-folder-create-modal.vue?vue&type=template&id=36e50ada&scoped=true"
import script from "./document-folder-create-modal.vue?vue&type=script&lang=js"
export * from "./document-folder-create-modal.vue?vue&type=script&lang=js"
import style0 from "./document-folder-create-modal.vue?vue&type=style&index=0&id=36e50ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e50ada",
  null
  
)

export default component.exports